import "../../../../assets/presentation/components/controls/text-input/text-input-error-message-CYLgewli.css";
/* empty css                         */
import classNames from "classnames";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/text-input/text-input-error-message.tsx
var TextInputErrorMessage = ({ className, children, testId }) => /* @__PURE__ */ jsx("p", {
	className: classNames(className, "text-input-error-message"),
	"data-testid": testId,
	children
});
//#endregion
export { TextInputErrorMessage };

//# sourceMappingURL=text-input-error-message2.js.map